import type { IAreActionsDisabled } from "@patternfly/react-table";
import { type Dispatch, type ReactNode, type SetStateAction, useState } from "react";
import type { IColumn } from "./PFTableV2";
import { TableContext } from "./TableContext";

export interface TableProps {
	columns: IColumn[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Table accepts various row shapes from different consumers
	rows: any[];
	totalItems?: number;
	children: ReactNode;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- action resolver receives varying row data types
	actionResolver?: any;
	areActionsDisabled?: IAreActionsDisabled;
	searchFunction?: (
		query: string,
		filterType?: string,
		filterValue?: string | number,
		setSelectedPage?: Dispatch<SetStateAction<number>>,
	) => void;
	selectItemsFunction?: (
		filter: string,
		currentPage: number,
		setSelectedPage: Dispatch<SetStateAction<number>>,
		perPage: number,
	) => void;
	disableBuiltInPagination?: boolean;
	selectionFilterValue?: string;
}

const Table = (props: TableProps) => {
	const [currentPage, setSelectedPage] = useState<number>(1);
	const [perPage, setPerPage] = useState<number>(10);
	const [selectionFilterValue, setSelectionFilter] = useState<string>(props.selectionFilterValue || "");
	const [searchValue, setSearchValue] = useState<string>("");

	return (
		<TableContext.Provider
			value={{
				columns: props.columns,
				rows: props.rows,
				totalItems: props.totalItems || 0,
				actionResolver: props.actionResolver,
				areActionsDisabled: props.areActionsDisabled ?? (() => false),
				searchFunction: props.searchFunction,
				selectItemsFunction: props.selectItemsFunction,
				perPage,
				searchValue,
				currentPage,
				selectionFilterValue,
				setSelectedPage,
				setPerPage,
				setSelectionFilter,
				setSearchValue,
				disableBuiltInPagination: props.disableBuiltInPagination,
			}}
		>
			{props.children}
		</TableContext.Provider>
	);
};

export default Table;
